"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncidentUpdateDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_validator_1 = require("class-validator");
const transform_config_1 = require("../../transform-config");
const class_transformer_1 = require("class-transformer");
const incident_participation_create_edit_dto_1 = require("./incident-participation-create-edit.dto");
const enums_1 = require("../../enums");
class IncidentUpdateDto extends mappable_base_1.MappableBase {
    constructor(option) {
        super();
        if (option)
            Object.assign(this, option);
    }
    getFields() {
        return [
            'date',
            'schoolId',
            'incidentTypeId',
            'incidentPlaceId',
            'description',
            'participants',
            'status',
            'deletedAt',
            'finalizedAt'
        ];
    }
    date;
    deletedAt;
    schoolId;
    incidentTypeId;
    incidentPlaceId;
    description;
    status;
    participants;
    getTransforms() {
        return [
            {
                destination: 'date',
                transform: transform_config_1.TransformConfig.transformDateToTimestamp('date'),
                sourceFields: ['date']
            }
        ];
    }
    finalizedAt;
}
exports.IncidentUpdateDto = IncidentUpdateDto;
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], IncidentUpdateDto.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((_, value) => value !== null),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : null)),
    __metadata("design:type", Object)
], IncidentUpdateDto.prototype, "deletedAt", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], IncidentUpdateDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], IncidentUpdateDto.prototype, "incidentTypeId", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], IncidentUpdateDto.prototype, "incidentPlaceId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(250),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], IncidentUpdateDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], IncidentUpdateDto.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => incident_participation_create_edit_dto_1.IncidentParticipationCreateEditDto),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], IncidentUpdateDto.prototype, "participants", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.status === enums_1.IncidentStatusEnum.FINALIZED),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Transform)(({ value }) => (value ? new Date(value) : null)),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], IncidentUpdateDto.prototype, "finalizedAt", void 0);
